import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SMMIcon } from "../components/icon.js";
export const AuthWidgetLeft = ({ leftRender, slogan }) => {
    if (leftRender === null)
        return null;
    if (leftRender !== undefined)
        return _jsx(_Fragment, { children: leftRender });
    return (_jsxs("div", { className: "bannerWrapper", children: [_jsx("div", { className: "logo", children: _jsx(SMMIcon, {}) }), _jsx("span", { className: "sloganText", children: slogan })] }));
};
//# sourceMappingURL=AuthWidgetLeft.js.map